import { buildTourApiUrl } from "api/configuration";
import { http } from "api/http";

export const sendCsvWithReport = (
  id: string
): Promise<boolean> => {
  const url = buildTourApiUrl(
    `/deliverytours/sendCsvWithReport/${id}`
  );
  return http.get(url, "Une erreur est survenue durant l'envoi du fichier", "Le fichier a bien été envoyé");
};
